var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.992,
    height: 50.964,
    viewBox: "0 0 41.992 50.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_111",
    "data-name": "Gruppe 111",
    transform: "translate(-344 -35.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_128",
    "data-name": "Pfad 128",
    d: "M8933.15,5491.071l23.314-6.461-11.313-6.7-12-7.839Z",
    transform: "translate(-8584.305 -5415.86)",
    fill: "#c8c4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_131",
    "data-name": "Pfad 131",
    d: "M8930.6,5488.568l22.61-6.46v-24.226l-22.61,6.46Z",
    transform: "translate(-8567.218 -5402.052)",
    fill: "#c8c4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_127",
    "data-name": "Pfad 127",
    d: "M8929.191,5489.294v-21.156l9.69-9.69,9.69,21v24.225l-6.46-4.844v-19.381l-8.075-4.845v17.765Z",
    transform: "translate(-8585.191 -5417.153)",
    fill: "#8f8bb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_129",
    "data-name": "Pfad 129",
    d: "M8932.27,5491.782l22.612-6.46-9.246-20.279-23.056,5.743Z",
    transform: "translate(-8568.89 -5429.492)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f5ac1da5fd441e5caf7c08712840b28d.svg";
export { ForwardRef as ReactComponent };